import { render, staticRenderFns } from "./WelcomeEmail.vue?vue&type=template&id=06b90679&"
import script from "./WelcomeEmail.vue?vue&type=script&lang=js&"
export * from "./WelcomeEmail.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WelcomeEmail.vue"
export default component.exports